module.exports = __webpack_public_path__ + "img/74.e7536446.jpg";